import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface CaseStudyCardProps {
  id: string;
  title: string;
  description: string;
  metrics: string[];
  image?: string;
  tags?: string[];
}
const CaseStudyCard: React.FC<CaseStudyCardProps> = ({
  id,
  title,
  description,
  metrics,
  image,
  tags
}) => {
  return <div className="bg-white rounded-lg overflow-hidden shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 group h-full flex flex-col" data-id="element-17">
      {image && <div className="h-48 overflow-hidden" data-id="element-18">
          <img src={image} alt={title} className="w-full h-full object-cover object-center transform transition-transform duration-500 group-hover:scale-105" data-id="element-19" />
        </div>}
      <div className="p-6 flex flex-col flex-grow" data-id="element-20">
        <div className="flex flex-wrap gap-2 mb-3" data-id="element-21">
          {tags?.map((tag, index) => <span key={index} className="px-2 py-1 text-xs font-medium bg-primary-50 text-primary-700 rounded-md" data-id="element-22">
              {tag}
            </span>)}
        </div>
        <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-23">{title}</h3>
        <p className="text-gray-600 mb-4 text-sm leading-relaxed flex-grow" data-id="element-24">
          {description}
        </p>
        <div className="mb-4" data-id="element-25">
          <h4 className="text-xs font-semibold text-gray-500 mb-2" data-id="element-26">
            Key Results:
          </h4>
          <ul className="space-y-1" data-id="element-27">
            {metrics.map((metric, index) => <li key={index} className="text-xs text-gray-600 flex items-start" data-id="element-28">
                <span className="mr-1 text-primary-600 font-bold" data-id="element-29">•</span>
                {metric}
              </li>)}
          </ul>
        </div>
        <Link to={`/case-study/${id}`} className="inline-flex items-center text-sm text-primary-600 font-medium hover:text-primary-800 transition-colors mt-auto" data-id="element-30">
          View Case Study{' '}
          <ArrowRightIcon className="ml-1 h-3 w-3 group-hover:ml-2 transition-all" data-id="element-31" />
        </Link>
      </div>
    </div>;
};
export default CaseStudyCard;